import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { POSTS } from "./posts";

export default function BlogIndex() {
  return (
    <div className="min-h-screen bg-[#0F0E13] text-[#F7F5F2]">
      <div className="max-w-5xl mx-auto px-6 py-16 lg:py-24">
        <div className="flex items-center justify-between mb-16">
          <Link to="/" className="flex items-center gap-2" data-testid="blog-index-logo">
            <Sparkles className="w-4 h-4 text-[#E3C2B0]" strokeWidth={1.5} />
            <span className="font-serif text-2xl">StyleMe</span>
          </Link>
          <Link
            to="/"
            data-testid="blog-index-home-link"
            className="text-xs uppercase tracking-[0.3em] text-[#A8A6A1] hover:text-[#F7F5F2]"
          >
            Home
          </Link>
        </div>

        <span className="text-xs uppercase tracking-[0.4em] text-[#E3C2B0]">Journal</span>
        <h1 className="font-serif text-5xl lg:text-7xl mt-4 font-light leading-[1.05]">
          Stories on style, taste & how to wear it.
        </h1>
        <p className="mt-6 text-[#A8A6A1] leading-relaxed max-w-2xl">
          Editorial pieces, shopping edits and small ideas for getting dressed with intention.
          New posts whenever the season turns.
        </p>

        <div className="mt-20 space-y-12" data-testid="blog-post-list">
          {POSTS.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className="grid md:grid-cols-[280px_1fr] gap-8 group items-start"
            >
              <div className="aspect-[4/5] overflow-hidden rounded-sm bg-[#1A1820]">
                <img
                  src={p.hero}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.04]"
                />
              </div>
              <div>
                <span className="text-xs uppercase tracking-[0.4em] text-[#E3C2B0]">
                  {p.category}
                </span>
                <h2 className="font-serif text-3xl lg:text-4xl mt-3 font-light leading-tight group-hover:text-[#E3C2B0] transition-colors">
                  {p.title}
                </h2>
                <p className="mt-4 text-[#D6D3CE] leading-relaxed">{p.excerpt}</p>
                <div className="mt-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#A8A6A1]">
                  <span>{p.author}</span>
                  <span className="w-1 h-1 rounded-full bg-[#A8A6A1]" />
                  <span>{p.date}</span>
                </div>
                <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#E3C2B0] group-hover:text-[#F0D4C5]">
                  Read post
                  <ArrowRight className="w-3 h-3 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
